"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameSymbol = void 0;
/** class name */
exports.nameSymbol = Symbol('className');
//# sourceMappingURL=ClassInfo.js.map